import { BaseModel } from '../../../_base/crud';

export class ContractorRateModel extends BaseModel {
	ContractorRateId: number;
	CompanyMId: number;
	ContractorMId: number;
	ProdCatMId: number;
	ProductRate: number;


	clear() {
		this.CompanyMId = undefined;
		this.ContractorMId = undefined;
		this.ProdCatMId = undefined;
		this.ProductRate = 0.00;
	}
}
